export const preventMinus = (e) => {
  if (e.code === "Minus") {
    e.preventDefault();
  }
};

export const formatInputPhoneNumber = (value, { isDeleting }) => {
  if (!value) return "";

  if (isDeleting && (value == "+" || value == "+1" || value == "+1 "))
    return value;

  if (value == "+" || value == "+1" || value == "+1 ") return value;

  const hasPlusOne = value.startsWith("+1");

  let digits = value.startsWith("+1")
    ? value.slice(2)
    : value.startsWith("+")
    ? value.slice(1)
    : value;

  digits = digits.replace(/\D/g, "").slice(0, 10);

  if (digits.length < 4) return hasPlusOne ? `+1 ${digits}` : digits;
  if (digits.length < 7)
    return hasPlusOne
      ? `+1 (${digits.slice(0, 3)}) ${digits.slice(3)}`
      : `(${digits.slice(0, 3)}) ${digits.slice(3)}`;

  return hasPlusOne
    ? `+1 (${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`
    : `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
};

export const isValidPhoneNumber = (phone) => {
  if (!phone) return false;

  // Remove all non-digit characters
  let digits = phone.replace(/\D/g, "");

  // If starts with '1' and length > 10, strip the leading 1 (country code)
  if (digits.startsWith("1") && digits.length > 10) {
    digits = digits.slice(1);
  }

  // Validate: exactly 10 digits
  return digits.length == 10;
};
